
define('text!modules/reporting/campaigns/performance/templates/chartLayout.html',[],function () { return '<div class="w-box w-Chart performance-chart-panel"></div>\n';});

